import styled from 'styled-components';

import { breakpoints } from '@notino/react-styleguide-v20';

export const StyledQuantityWrapper = styled.div``;

export const StyledDisabledText = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 2.8125rem;
  width: 100%;
  min-width: 5.3125rem;
`;

export const StyledText = styled.span`
  padding-right: 1.1875rem;

  @media (min-width: ${breakpoints.sm}) {
    padding-right: 2.25rem;
    padding-left: 1rem;
  }
`;
